// extracted by mini-css-extract-plugin
module.exports = {"input":"oHhuqtcrDpufP1xA42jDB"};